// TAGS_SERVICE_ERROR
// TRANSACTION_SERVICE_ERROR
// OTHER_EVENT_ERROR
import AppDispatcher from '../dispatcher/AppDispatcher';
import { EventEmitter } from 'events';
import _ from 'lodash';
import { CHANGE_EVENT } from '../constants/AppConstants';
import TransactionsConstants from '../constants/TransactionsConstants';
import TransactionsApiUtils from '../utils/TransactionsApiUtils';
import AccountsStore from '../stores/AccountsStore';
import { sortCurrency } from '../components/payment-fate/PaymentHistoryHelper.js';
import AccountPoolsStore from './AccountPoolsStore';

const TRANSACTIONS_PER_PAGE = 25;
const LOOKUP_LIMIT = 10000 - TRANSACTIONS_PER_PAGE;

let _transactions = [];
let _categoryTags = [];
let _customTags = [];
let _fromTransactionIndex = 0;
let _fromTransactionIndexPerAccount = [];
let _loadTransactions = false;
let _loadSearchTransactions = false;
let _sortOrder = 'desc';
let _sortField = 'details.when';
let _typeFilter = 'all';
let _selectedAccount = AccountsStore.getAccount();
let _searchText = '';
let _fromSearchTransactionIndex = 0;
let _suggestData = [];
let _addNewTag = '';
let _editTagValue = '';
let _deleteTagId = '';
let _keyid = '';
let _popUpFlag = false;
let _searchTransactions = [];
let _onSearchTransaction = false;
// let _startDate = moment().startOf('days');
// _startDate = _startDate.subtract(3, 'months');
// let _endDate = moment();
let _startDate = '';
let _endDate = '';
let _isLoadingFlag = false;
let _serviceErrorFlag = false;
let _untaggedTag = {};
let _tagsAssigned = false;
let _loader = false;
let _tagsServiceErrorFlag = false;
let _transactionServiceErrorFlag = false;
let _otherEventsErrorFlag = false;
let _assignTagError = false;
let _statusResponse = '';
let transactionsErrorMessage = '';
let tagsErrorMessage = '';
let assignTagErrorMessage = '';
let applyFilterBtnStatusFlag = null;

const setSingleTransactionIndex = (accountId, value) => {
  // find the account id and set its value separately
  _fromTransactionIndexPerAccount.forEach((account, idx) => {
    if (account.accountId === accountId) {
      _fromTransactionIndexPerAccount[idx].fromTransactionIndex = value;
    }
  });
};

const getSingleTransactionIndex = (accountId) => {
  const transactionIndex = _fromTransactionIndexPerAccount.find(
    (account) => account.accountId === accountId
  );
  return transactionIndex.fromTransactionIndex;
};

const setFromTransactionIndexPerAccount = (accountIds, value) => {
  if (Array.isArray(accountIds)) {
    accountIds.forEach((accountId, idx) => {
      _fromTransactionIndexPerAccount[idx] = {
        accountId,
        fromTransactionIndex: value,
      };
    });
  } else {
    // find the account and set its count individually
    setSingleTransactionIndex(accountIds, value);
  }
};

// Order of sorting for the debit and credit columns, based on the column to sort and the sort order.
const sortOrderLookUp = {
  desc: {
    credit: ['debit', 'credit'],
    debit: ['credit', 'debit'],
  },
  asc: {
    debit: ['debit', 'credit'],
    credit: ['credit', 'debit'],
  },
};

export const sortDebitCreditColumns = (sortDirection, sortColumn) => {
  const columnsOrder = sortOrderLookUp[sortDirection][sortColumn];
  const firstColumn = columnsOrder[0];
  const secondColumn = columnsOrder[1];

  if (sortDirection === 'desc') {
    _transactions = _transactions.sort((a, b) =>
      sortCurrency(b[firstColumn], a[firstColumn])
    ); // Sort by the first column
    _transactions = _transactions.sort((a, b) =>
      sortCurrency(b[secondColumn], a[secondColumn])
    ); // and then by the second
  } else {
    _transactions = _transactions.sort((a, b) =>
      sortCurrency(a[firstColumn], b[firstColumn])
    );
    _transactions = _transactions.sort((a, b) =>
      sortCurrency(a[secondColumn], b[secondColumn])
    );
  }
};

class TransactionsStoreNew extends EventEmitter {
  constructor() {
    super();
    this.dispatchToken = AppDispatcher.register(
      this.dispatcherCallback.bind(this)
    );
  }
  emitChange() {
    this.emit(CHANGE_EVENT);
  }

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
    _transactions = [];
    _categoryTags = [];
    _customTags = [];
    _fromTransactionIndex = 0;
    _fromTransactionIndexPerAccount = [];
    _loadTransactions = true;
    _sortOrder = '';
    _sortField = '';
    _typeFilter = '';
  }

  getTransactions() {
    return _transactions;
  }
  getTransactionAmountLength() {
    let higherLength = false;
    _.map(_transactions, (transaction) => {
      if (transaction.amount.length > 10) {
        higherLength = true;
      }
    });
    return higherLength;
  }
  getTransactionBalanceLength() {
    let higherBalance = false;
    _.map(_transactions, (transaction) => {
      if (transaction.balance.length > 11) {
        higherBalance = true;
      }
    });
    return higherBalance;
  }
  getLoadTransactions() {
    return _onSearchTransaction ? _loadSearchTransactions : _loadTransactions;
  }
  getSortField() {
    return _sortField;
  }
  getSortOrder() {
    return _sortOrder;
  }
  getTypeFilter() {
    return _typeFilter;
  }
  getCategoryTags() {
    return _categoryTags;
  }
  getCustomTags() {
    return _customTags;
  }
  getSearchText() {
    return _searchText;
  }
  getSuggestData() {
    return _suggestData;
  }
  getPopUpFlag() {
    return _popUpFlag;
  }

  getSearchTransactionFlag() {
    return _onSearchTransaction;
  }
  getLoader() {
    return _isLoadingFlag;
  }
  getUntagged() {
    return _untaggedTag;
  }
  getTagAssignedFlag() {
    return _tagsAssigned;
  }
  getShowMoreLoader() {
    return _loader;
  }
  getErrorFlag() {
    return _serviceErrorFlag;
  }
  getTagsServiceErrorFlag() {
    return _tagsServiceErrorFlag;
  }
  getTransactionsServiceErrorFlag() {
    return _transactionServiceErrorFlag;
  }
  getOtherEventsErrorFlag() {
    return _otherEventsErrorFlag;
  }
  getTagsErrorMessage() {
    return tagsErrorMessage;
  }
  getTransactionsErrorMessage() {
    return transactionsErrorMessage;
  }
  getStatusResponse() {
    return _statusResponse;
  }
  getAssignTagError() {
    return _assignTagError;
  }
  getAssignTagErrorMessage() {
    return assignTagErrorMessage;
  }
  getApplyFilterBtnstatus() {
    return applyFilterBtnStatusFlag;
  }

  hasReachedLookupLimit() {
    if (_onSearchTransaction) {
      return _fromSearchTransactionIndex >= LOOKUP_LIMIT;
    }

    return _fromTransactionIndex >= LOOKUP_LIMIT;
  }

  dispatcherCallback(data) {
    const actionType = data.action.actionType;
    const actionData = data.action;
    switch (actionType) {
      case TransactionsConstants.REQUEST_TRANSACTION_LIST_NEW:
        _popUpFlag = false;
        // _serviceErrorFlag = false;
        _onSearchTransaction = false;
        _tagsAssigned = false;
        _popUpFlag = false;
        _transactionServiceErrorFlag = false;
        _assignTagError = false;
        if (
          actionData.sortField !== _sortField ||
          actionData.sortOrder !== _sortOrder ||
          actionData.typeFilter !== _typeFilter ||
          _selectedAccount !== actionData.id ||
          actionData.startDate !== _startDate ||
          actionData.endDate !== _endDate
        ) {
          _fromTransactionIndex = 0;
          setFromTransactionIndexPerAccount(
            actionData.id,
            _fromTransactionIndex
          );
          _transactions = [];
          _sortField = actionData.sortField;
          _sortOrder = actionData.sortOrder;
          _typeFilter = actionData.typeFilter;
          _startDate = actionData.startDate;
          _endDate = actionData.endDate;
        }

        /**
         * Edge case - we should never end up in here.
         * Part of "needle in a haystack" fix for one Business user
         * @see {@link https://enterprisevm.atlassian.net/browse/CX-20688}
         */
        if (this.hasReachedLookupLimit()) {
          return;
        }

        _transactions.length > 0 ? (_loader = true) : (_isLoadingFlag = true);
        _selectedAccount = actionData.id;
        _typeFilter === 'all'
          ? TransactionsApiUtils.getTransactions(
              _selectedAccount,
              _sortField,
              _sortOrder,
              _fromTransactionIndex,
              _startDate,
              _endDate
            )
          : TransactionsApiUtils.getFilteredTransactions(
              actionData.id,
              _sortField,
              _sortOrder,
              _fromTransactionIndex,
              _typeFilter,
              _startDate,
              _endDate
            );
        _fromTransactionIndex = _fromTransactionIndex + TRANSACTIONS_PER_PAGE;
        setFromTransactionIndexPerAccount(
          _selectedAccount,
          _fromTransactionIndex
        );
        break;

      case TransactionsConstants.REQUEST_TRANSACTION_LIST_SUCCESS_NEW:
        _loader = false;
        _isLoadingFlag = false;
        _popUpFlag = false;
        _transactionServiceErrorFlag = false;
        _assignTagError = false;
        const _fetchTransactions = actionData.data;
        if (_onSearchTransaction) {
          _transactions = [];
          _loadTransactions = false;
          _loadSearchTransactions =
            _fetchTransactions.length < TRANSACTIONS_PER_PAGE ? false : true;
          _searchTransactions = _.concat(
            _searchTransactions,
            _fetchTransactions
          );
          _transactions = _searchTransactions;
        } else {
          _loadTransactions =
            _fetchTransactions.length < TRANSACTIONS_PER_PAGE ? false : true;
          _transactions = _.concat(_transactions, _fetchTransactions);
        }

        if (AccountsStore.isEnriched()) {
          // Single Account View - for both Retail and Business customers
          TransactionsApiUtils.getEnrichedData(_fetchTransactions);
        } else if (AccountPoolsStore.isSpecificPoolDetailsLoaded()) {
          // DP - Enriching Account Pool transactions is out of scope (for now)
          // const enrichedIds = AccountPoolsStore.getEnrichedAccountIdsFromPool();
          // if (enrichedIds.length > 0) {
          //   TransactionsApiUtils.getEnrichedData(
          //     _fetchTransactions.filter(({ accountId }) =>
          //       enrichedIds.includes(accountId)
          //     )
          //   );
          // }
        }

        /**
         * Edge case - we should never end up in here.
         * Part of "needle in a haystack" fix for one Business user
         * @see {@link https://enterprisevm.atlassian.net/browse/CX-20688}
         */
        if (this.hasReachedLookupLimit()) {
          _loadTransactions = false;
        }

        this.emitChange();
        break;

      case TransactionsConstants.REQUEST_ENRICHED_DATA_SUCCESS:
        const { data: newlyRequestedEnrichedData } = actionData;

        // Edge case: third Party API error, or lack of response.
        if (!newlyRequestedEnrichedData) {
          return;
        }

        _transactions = _transactions.map((transaction) => {
          if (transaction.isEnrichAttempted) {
            return transaction;
          }

          transaction.enrich(newlyRequestedEnrichedData.get(transaction.id));

          return transaction;
        });

        this.emitChange();
        break;

      case TransactionsConstants.REQUEST_TAGS:
        _categoryTags = [];
        _customTags = [];
        // _serviceErrorFlag = false;
        _tagsAssigned = false;
        _tagsServiceErrorFlag = false;
        _assignTagError = false;
        TransactionsApiUtils.getTags();
        break;

      case TransactionsConstants.REQUEST_TAGS_SUCCESS:
        // _serviceErrorFlag = false;
        _tagsServiceErrorFlag = false;
        _assignTagError = false;
        _tagsAssigned = false;
        _.map(actionData.data, (tag) => {
          if (tag.value === 'Untagged') {
            _untaggedTag = tag;
          } else {
            if (tag.categoryBudget) {
              _categoryTags.push(tag);
            } else {
              _customTags.push(tag);
            }
          }
        });
        _categoryTags = _.sortBy(_categoryTags, 'value');
        _customTags = _.sortBy(_customTags, 'value');
        // if (_onSearchTransaction) {
        //     _fromSearchTransactionIndex = 0;
        //     _searchTransactions = [];
        //     _typeFilter === 'all' ? TransactionsApiUtils.getSearchTransactions(_selectedAccount, _sortField, _sortOrder, _fromSearchTransactionIndex, _suggestData, _startDate, _endDate) : TransactionsApiUtils.getFilteredSearchTransactions(_selectedAccount, _sortField, _sortOrder, _typeFilter, _fromSearchTransactionIndex, _suggestData, _startDate, _endDate);
        //     _fromSearchTransactionIndex = _fromSearchTransactionIndex + TRANSACTIONS_PER_PAGE;
        // } else {
        //     _fromTransactionIndex = 0;
        //     _transactions = [];
        //     _typeFilter === 'all' ? TransactionsApiUtils.getTransactions(_selectedAccount, _sortField, _sortOrder, _fromTransactionIndex, _startDate, _endDate) : TransactionsApiUtils.getFilteredTransactions(_selectedAccount, _sortField, _sortOrder, _fromTransactionIndex, _typeFilter, _startDate, _endDate);
        //     _fromTransactionIndex = _fromTransactionIndex + TRANSACTIONS_PER_PAGE;
        // }
        this.emitChange();
        break;

      case TransactionsConstants.REQUEST_TAG_SELECTED_TRANSACTIONS:
        _tagsServiceErrorFlag = false;
        _assignTagError = false;
        _transactionServiceErrorFlag = false;
        _isLoadingFlag = true;
        const transactions = actionData.transactions;
        const tag = actionData.tag;
        const accountId = actionData.accountId;
        TransactionsApiUtils.tagSelectedTransactions(
          transactions,
          tag,
          accountId
        );
        break;

      case TransactionsConstants.REQUEST_TAG_SELECTED_TRANSACTIONS_SUCCESS:
        _tagsAssigned = false;
        _assignTagError = false;
        _tagsServiceErrorFlag = false;
        _transactionServiceErrorFlag = false;
        _isLoadingFlag = false;
        if (_onSearchTransaction) {
          _fromSearchTransactionIndex = 0;
          _searchTransactions = [];
          _typeFilter === 'all'
            ? TransactionsApiUtils.getSearchTransactions(
                _selectedAccount,
                _sortField,
                _sortOrder,
                _fromSearchTransactionIndex,
                _suggestData,
                _startDate,
                _endDate
              )
            : TransactionsApiUtils.getFilteredSearchTransactions(
                _selectedAccount,
                _sortField,
                _sortOrder,
                _typeFilter,
                _fromSearchTransactionIndex,
                _suggestData,
                _startDate,
                _endDate
              );
          _fromSearchTransactionIndex =
            _fromSearchTransactionIndex + TRANSACTIONS_PER_PAGE;
        } else {
          _fromTransactionIndex = 0;
          _transactions = [];
          _typeFilter === 'all'
            ? TransactionsApiUtils.getTransactions(
                _selectedAccount,
                _sortField,
                _sortOrder,
                _fromTransactionIndex,
                _startDate,
                _endDate
              )
            : TransactionsApiUtils.getFilteredTransactions(
                _selectedAccount,
                _sortField,
                _sortOrder,
                _fromTransactionIndex,
                _typeFilter,
                _startDate,
                _endDate
              );
          _fromTransactionIndex = _fromTransactionIndex + TRANSACTIONS_PER_PAGE;
          setFromTransactionIndexPerAccount(
            _selectedAccount,
            _fromTransactionIndex
          );
        }
        _tagsAssigned = true;
        break;

      case TransactionsConstants.REQUEST_SEARCH_SUGGESTION:
        _searchText = actionData.searchText;
        _assignTagError = false;
        _fromSearchTransactionIndex = 0;
        _searchTransactions = [];
        TransactionsApiUtils.getTransactionsSearchSuggestion(
          _searchText,
          _selectedAccount
        );
        break;

      case TransactionsConstants.REQUEST_SEARCH_SUGGESTION_SUCCESS:
        _tagsServiceErrorFlag = false;
        _assignTagError = false;
        _transactionServiceErrorFlag = false;
        _suggestData = actionData.suggestData;
        if (_suggestData.length > 0) {
          _popUpFlag = true;
        } else {
          _popUpFlag = false;
        }
        // _serviceErrorFlag = false;
        _tagsAssigned = false;
        this.emitChange();
        break;

      case TransactionsConstants.REQUEST_SEARCH_TRANSACTIONS:
        _tagsAssigned = false;
        _popUpFlag = false;
        _assignTagError = false;
        _onSearchTransaction = true;
        if (
          actionData.suggestData !== _suggestData ||
          actionData.sortField !== _sortField ||
          actionData.sortOrder !== _sortOrder ||
          actionData.typeFilter !== _typeFilter ||
          actionData.startDate !== _startDate ||
          actionData.endDate !== _endDate
        ) {
          _suggestData = actionData.suggestData;
          _fromSearchTransactionIndex = 0;
          _searchTransactions = [];
          _sortField = actionData.sortField;
          _sortOrder = actionData.sortOrder;
          _typeFilter = actionData.typeFilter;
          _startDate = actionData.startDate;
          _endDate = actionData.endDate;
        }
        _searchTransactions.length > 0
          ? (_loader = true)
          : (_isLoadingFlag = true);
        _typeFilter === 'all'
          ? TransactionsApiUtils.getSearchTransactions(
              _selectedAccount,
              _sortField,
              _sortOrder,
              _fromSearchTransactionIndex,
              _suggestData,
              _startDate,
              _endDate
            )
          : TransactionsApiUtils.getFilteredSearchTransactions(
              _selectedAccount,
              _sortField,
              _sortOrder,
              _typeFilter,
              _fromSearchTransactionIndex,
              _suggestData,
              _startDate,
              _endDate
            );
        _fromSearchTransactionIndex =
          _fromSearchTransactionIndex + TRANSACTIONS_PER_PAGE;
        break;

      case TransactionsConstants.REQUEST_ADD_NEW_TAG:
        _assignTagError = false;
        _addNewTag = actionData.newTag;
        TransactionsApiUtils.addNewTag(_addNewTag);
        break;

      case TransactionsConstants.REQUEST_EDIT_TAG:
        _keyid = actionData.keyid;
        _editTagValue = actionData.editTagValue;
        _assignTagError = false;
        TransactionsApiUtils.editExistingTag(_keyid, _editTagValue);
        break;

      case TransactionsConstants.REQUEST_DELETE_TAG:
        _deleteTagId = actionData.deleteTagId;
        _assignTagError = false;
        TransactionsApiUtils.deleteExistingTag(_deleteTagId);
        break;

      case TransactionsConstants.RESET_SEARCH:
        _popUpFlag = false;
        _assignTagError = false;
        _onSearchTransaction = false;
        _searchTransactions = [];
        _searchText = '';
        _fromSearchTransactionIndex = 0;
        _fromTransactionIndex = 0;
        _transactions = [];
        _popUpFlag = false;
        _isLoadingFlag = true;
        _tagsAssigned = false;
        _typeFilter === 'all'
          ? TransactionsApiUtils.getTransactions(
              _selectedAccount,
              _sortField,
              _sortOrder,
              _fromTransactionIndex,
              _startDate,
              _endDate
            )
          : TransactionsApiUtils.getFilteredTransactions(
              _selectedAccount,
              _sortField,
              _sortOrder,
              _fromTransactionIndex,
              _typeFilter,
              _startDate,
              _endDate
            );
        _fromTransactionIndex = _fromTransactionIndex + TRANSACTIONS_PER_PAGE;
        break;

      case TransactionsConstants.RESET_POPUP:
        _popUpFlag = false;
        // _serviceErrorFlag = false;
        _tagsAssigned = false;
        _assignTagError = false;
        _tagsServiceErrorFlag = false;
        _transactionServiceErrorFlag = false;
        this.emitChange();
        break;

      case TransactionsConstants.TAGS_SERVICE_ERROR:
        _tagsServiceErrorFlag = true;
        _assignTagError = false;
        tagsErrorMessage = actionData.tagsErrorMessage;
        break;
      case TransactionsConstants.TRANSACTION_SERVICE_ERROR:
        _transactionServiceErrorFlag = true;
        _assignTagError = false;
        transactionsErrorMessage = actionData.transactionsErrorMessage;
        _statusResponse = actionData.statusResponse;
        this.emitChange();
        break;
      case TransactionsConstants.OTHER_EVENT_ERROR:
        _otherEventsErrorFlag = true;
        _assignTagError = false;

        break;
      case TransactionsConstants.SERVICE_ERROR:
        _serviceErrorFlag = true;
        _assignTagError = false;
        break;
      case TransactionsConstants.REQUEST_TAG_SELECTED_TRANSACTIONS_ERROR:
        _assignTagError = true;
        assignTagErrorMessage = actionData.assignTagError;
        this.emitChange();
        break;
      case TransactionsConstants.ENRICHED_DATA_SERVICE_ERROR:
        /**
         * As per non-blocking design -
         * we do not care about the errors from /transactions/enrich
         */
        break;
      case TransactionsConstants.SET_APPLY_FILTER_STATUS:
        applyFilterBtnStatusFlag = actionData.data;
        this.emitChange();
        break;
      case TransactionsConstants.REQUEST_TRANSACTIONS_ACCOUNT_POOL:
        _popUpFlag = false;
        _onSearchTransaction = false;
        _tagsAssigned = false;
        _popUpFlag = false;
        _transactionServiceErrorFlag = false;
        _assignTagError = false;
        if (
          actionData.sortField !== _sortField ||
          actionData.sortOrder !== _sortOrder ||
          actionData.typeFilter !== _typeFilter ||
          actionData.startDate !== _startDate ||
          actionData.endDate !== _endDate
        ) {
          if (!actionData.isPerAccount) {
            _fromTransactionIndex = 0;
            _transactions = [];
          }
          _sortField = actionData.sortField;
          _sortOrder = actionData.sortOrder;
          _typeFilter = actionData.typeFilter;
          _startDate = actionData.startDate;
          _endDate = actionData.endDate;
        }
        _transactions.length > 0 ? (_loader = true) : (_isLoadingFlag = true);
        _selectedAccount = actionData.id;

        const fromTransactionIndex = actionData.isPerAccount
          ? getSingleTransactionIndex(actionData.id)
          : _fromTransactionIndex;

        _typeFilter === 'all'
          ? TransactionsApiUtils.getTransactions(
              _selectedAccount,
              _sortField,
              _sortOrder,
              fromTransactionIndex,
              _startDate,
              _endDate
            )
          : TransactionsApiUtils.getFilteredTransactions(
              _selectedAccount,
              _sortField,
              _sortOrder,
              _fromTransactionIndex,
              _typeFilter,
              _startDate,
              _endDate
            );

        //  TODO: reset _fromTransactionIndex on change of tab since it will be out of alignment
        if (!actionData.isPerAccount) {
          _fromTransactionIndex = _fromTransactionIndex + TRANSACTIONS_PER_PAGE;
          setFromTransactionIndexPerAccount(
            actionData.id,
            _fromTransactionIndex
          );
        } else {
          const updatedFromTransactionIndex =
            getSingleTransactionIndex(actionData.id) + TRANSACTIONS_PER_PAGE;
          setFromTransactionIndexPerAccount(
            actionData.id,
            updatedFromTransactionIndex
          );
        }
        break;

      case TransactionsConstants.SORT_SME_TRANSACTIONS:
        const { sortColumn, sortDirection } = actionData;
        sortDebitCreditColumns(sortDirection, sortColumn);
        this.emitChange();
        break;
      default: {
        break;
      }
    }
  }
}
export default new TransactionsStoreNew();
